/**
* Created by vouill on 6/7/18.
*/

<template>
  <div>
    Component logout
  </div>
</template>

<script>
export default {
  name: "Logout",
  props: {},
  components: {},
  created: function() {
    localStorage.removeItem("token");
    this.$router.push("/");
    location.reload();
  },
  data() {
    return {};
  }
};
</script>
